<template>
  <div class="max-w-3xl mx-auto">
    <div
      v-if="$page.props.flash.success && show"
      class="mt-4 mb-8 flex items-center justify-between bg-green-100 border border-green-900 rounded text-green-900"
    >
      <div class="flex items-center">
        <svg class="ml-4 mr-2 shrink-0 w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
        </svg>
        <div class="py-4 text-sm font-medium">
          {{ $page.props.flash.success }}
        </div>
      </div>
      <button type="button" class="group mr-2 p-2" @click="show = false">
        <svg
          class="block w-2 h-2 fill-current hover:opacity-60"
          xmlns="http://www.w3.org/2000/svg"
          width="235.908"
          height="235.908"
          viewBox="278.046 126.846 235.908 235.908"
        >
          <path
            d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
          />
        </svg>
      </button>
    </div>
    <div
      v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show"
      class="mb-8 flex items-center justify-between bg-red-light rounded max-w-3xl text-grey-90"
    >
      <div class="flex items-center">
        <svg
          class="ml-4 mr-2 shrink-0 w-4 h-4 fill-current"
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5779 17.9707H17.2143C18.8196 17.9707 19.7923 16.8565 19.7923 15.4117C19.7923 14.9679 19.6601 14.5052 19.424 14.0897L12.0963 1.32297C11.6053 0.463669 10.7649 0.0292969 9.89613 0.0292969C9.02738 0.0292969 8.17754 0.463669 7.69595 1.32297L0.368272 14.0897C0.113315 14.5146 0 14.9679 0 15.4117C0 16.8565 0.972616 17.9707 2.5779 17.9707ZM2.58735 16.4882C1.92635 16.4882 1.52975 15.9783 1.52975 15.4023C1.52975 15.2229 1.56752 14.9962 1.67139 14.7979L8.98962 2.04063C9.1879 1.69124 9.54674 1.54016 9.89613 1.54016C10.2455 1.54016 10.5949 1.69124 10.7932 2.04063L18.1114 14.8074C18.2153 15.0057 18.2625 15.2229 18.2625 15.4023C18.2625 15.9783 17.847 16.4882 17.1955 16.4882H2.58735Z"
            fill="#292E56"
          />
          <path
            d="M9.89596 11.6074C10.3492 11.6074 10.6136 11.343 10.6231 10.8519L10.7553 5.87559C10.7647 5.39399 10.387 5.03516 9.88651 5.03516C9.3766 5.03516 9.01776 5.38454 9.02721 5.86614L9.14996 10.8519C9.15941 11.3335 9.42382 11.6074 9.89596 11.6074ZM9.89596 14.6763C10.4436 14.6763 10.9158 14.242 10.9158 13.6942C10.9158 13.1371 10.4531 12.7122 9.89596 12.7122C9.33884 12.7122 8.8761 13.1466 8.8761 13.6942C8.8761 14.2325 9.34824 14.6763 9.89596 14.6763Z"
            fill="#292E56"
          />
        </svg>
        <div v-if="$page.props.flash.error" class="py-4 text-sm font-medium">
          {{ $page.props.flash.error }}
        </div>
        <div v-else class="py-4 text-sm font-medium">
          {{ $tc('common.errors.validation', Object.keys($page.props.errors).length) }}
        </div>
      </div>
      <button type="button" class="group mr-2 p-2" @click="show = false">
        <svg
          class="block w-2 h-2 fill-current hover:opacity-60"
          xmlns="http://www.w3.org/2000/svg"
          width="235.908"
          height="235.908"
          viewBox="278.046 126.846 235.908 235.908"
        >
          <path
            d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },

  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
